const { Map } = require('immutable');
const resolveResourceAttributes = (resource) => {
	return resource.withMutations((map) => {
		return map
						.get('attributes', [])
						.reduce((reduction, attribute, name) => { 
							return reduction.set(name, attribute); 
						}, map);
	}).delete('attributes');
};
const titleSelector = (state) => {
	const selected = state.getIn(['resources', state.get('selectedResource')], Map());
	const resource = resolveResourceAttributes(state.getIn(['cache', state.get('selectedResource')], Map()));
	
	if(selected.get('isFetching')) {
		return 'Sidan laddas...';
	}

	return resource.get('title', 'Sidan kunde inte laddas') + ' | svt.se';
};

module.exports = titleSelector;



/** WEBPACK FOOTER **
 ** ./app/selectors/titleSelector.js
 **/